if (!customElements.get('product-personalization-field')) {
  customElements.define(
    'product-personalization-field',
    class ProductPersonalizationField extends HTMLElement {
      constructor() {
        super();
        this.handleSubmit = this.handleSubmit.bind(this);
      }

      connectedCallback() {
        this.input = this.querySelector('[data-personalization-input]');
        this.form = this.input?.form;
        this.form?.addEventListener('submit', this.handleSubmit, true);
      }

      disconnectedCallback() {
        this.form?.removeEventListener('submit', this.handleSubmit, true);
      }

      handleSubmit(event) {
        if (!this.input || this.input.checkValidity()) return;

        event.preventDefault();
        event.stopImmediatePropagation();
        this.input.reportValidity();
        this.input.focus();
      }
    }
  );
}
